import * as React from 'react';
import { IFormCellProps } from '../FormCell';
import { Grid } from '../Grid';
import { mergeTests } from '../../test-utilities/mergeTests';
import styled from 'styled-components';
import { BodyText } from '../Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { InputCss, hoverInputStyle, disabledInputStyle } from '../TextInput';

interface ICheckboxIconInputAndLabelProps extends Omit<IFormCellProps, 'label'> {
  disabled: boolean;
  readOnly: boolean;
  text?: string;
  checked: boolean;
  focused: boolean;
}

const CheckboxWrapper = styled.div<ICheckboxIconInputAndLabelProps>`
  ${InputCss};
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  height: 16px;
  width: 16px;
  padding: unset;

  ${(props) =>
    props.disabled
      ? disabledInputStyle
      : `&:hover {
    ${hoverInputStyle};
    border-radius: 4px;
  }
  `};

  ${(props) =>
    props.checked
      ? props.disabled
        ? ``
        : `background: ${props.theme.colors.defaultContentText};
  border:2px solid ${props.theme.colors.defaultContentText}`
      : ``};

  ${(props) => {
    if (props.checked && !props.disabled) {
      if (props.focused) {
        return `
          background: ${props.theme.colors.defaultContentText};
          border:2px solid ${props.theme.colors.primary};

          &:hover {
            background: ${props.theme.colors.defaultContentText};
            border:2px solid ${props.theme.colors.primary};
          }
        `;
      }

      return `
        &:hover {
          border-color: ${props.theme.colors.black};
          background: ${props.theme.colors.black};
        }
      `;
    }

    if (props.focused) {
      return `
      border:2px solid ${props.theme.colors.primary}
      background: ${props.theme.colors.gray200};

      &:hover {
      border:2px solid ${props.theme.colors.primary}
      background: ${props.theme.colors.gray200};
      }
      `;
    }

    return '';
  }}
`;

const StyledIcon = styled(FontAwesomeIcon)`
  color: ${(props) => props.theme.colors.white};
  height: 11px;
  width: 8px;
`;

const StyledBodyText = styled(BodyText)<{ disabled?: boolean }>`
  color: ${(props) => (props.disabled ? props.theme.colors.secondarySelectedBackground : props.theme.colors.gray700)};
`;

export const CheckboxIconInputAndLabel: React.FC<ICheckboxIconInputAndLabelProps> = (props) => {
  const { checked, disabled, text } = props;
  const dataTestClass = props['data-test-class'] || 'check-box';

  return (
    <Grid columnCount={2} templateColumns={`min-content max-content`} alignItems="center" columnGap={'spacing3'}>
      <CheckboxWrapper {...props}>
        {checked && <StyledIcon icon={faCheck} size={'lg'} data-test-class={mergeTests(dataTestClass, 'icon')} />}
      </CheckboxWrapper>
      {text && (
        <StyledBodyText disabled={disabled} data-test-class={mergeTests(dataTestClass, 'text')}>
          {text}
        </StyledBodyText>
      )}
    </Grid>
  );
};
